"use client";

import { useQuery } from "@tanstack/react-query";
import { createContext, type ReactNode, useContext } from "react";
import { useGraphql } from "~/api-client";

const currencyContext = createContext("");

/**
 * use the currency in the current context, eg "AUD"
 */
export default function useCurrency() {
  return useContext(currencyContext);
}

export function CurrencyProvider(props: {
  currency: string;
  children: ReactNode;
}) {
  return (
    <currencyContext.Provider value={props.currency}>
      {props.children}
    </currencyContext.Provider>
  );
}

export function OrganizationCurrencyProvider(props: { children: ReactNode }) {
  const { getMerchant } = useGraphql();
  const { data } = useQuery({
    queryKey: ["merchant"],
    queryFn: getMerchant,
    refetchOnWindowFocus: false,
  });

  return (
    <CurrencyProvider currency={data?.merchant.currency || ""}>
      {props.children}
    </CurrencyProvider>
  );
}
